import { SvgIcon, SvgIconProps } from '@mui/material'

const NoTraveller = (props: SvgIconProps) => (
    <SvgIcon {...props} viewBox="0 0 70 56" fill="none">
        <path
            d="M64.1432 54.7234H5.60116C2.90957 54.7234 0.722656 52.5365 0.722656 49.8449V12.3309C0.722656 9.63931 2.90957 7.45239 5.60116 7.45239H64.1432C66.8348 7.45239 69.0217 9.63931 69.0217 12.3309V50.0131C68.8535 52.5365 66.6666 54.7234 64.1432 54.7234Z"
            fill="white"
            stroke="#CAD5E2"
            strokeWidth="1.44682"
            strokeMiterlimit="10"
        />
        <rect
            x="10.8926"
            y="9.1814"
            width="11.1024"
            height="3.72764"
            fill="#F1F3FA"
            stroke="#CAD5E2"
            strokeWidth="1.44682"
            strokeMiterlimit="10"
        />
        <rect
            x="47.3613"
            y="9.1814"
            width="10.8478"
            height="3.72764"
            fill="#F1F3FA"
            stroke="#CAD5E2"
            strokeWidth="1.44682"
            strokeMiterlimit="10"
        />
        <path
            d="M20.0657 10.8983V4.34021C20.0657 2.34269 18.4464 0.723389 16.4489 0.723389C14.4513 0.723389 12.832 2.3427 12.832 4.34021V10.8983H20.0657Z"
            fill="white"
            stroke="#CAD5E2"
            strokeWidth="1.44682"
            strokeMiterlimit="10"
        />
        <path
            d="M56.4055 10.8983V4.34021C56.4055 2.34269 54.7862 0.723389 52.7887 0.723389C50.7912 0.723389 49.1719 2.3427 49.1719 4.34021V10.8983H56.4055Z"
            fill="white"
            stroke="#CAD5E2"
            strokeWidth="1.44682"
            strokeMiterlimit="10"
        />
        <path
            d="M24.8058 32.9771C27.2227 32.9771 29.182 31.0179 29.182 28.601C29.182 26.1841 27.2227 24.2249 24.8058 24.2249C22.389 24.2249 20.4297 26.1841 20.4297 28.601C20.4297 31.0179 22.389 32.9771 24.8058 32.9771Z"
            fill="none"
            stroke="#90A1B9"
            strokeWidth="1.71078"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M17.7793 40.1399C17.7793 36.2942 20.9619 33.1116 24.8077 33.1116C28.6534 33.1116 31.836 36.2942 31.836 40.1399"
            fill="none"
            stroke="#90A1B9"
            strokeWidth="1.71078"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M39.127 27.7683H55.7654"
            stroke="#90A1B9"
            strokeWidth="1.71078"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M39.127 35.0024H45.6376"
            stroke="#90A1B9"
            strokeWidth="1.71078"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </SvgIcon>
)

export default NoTraveller

